import ko from 'knockout';
import generate from '@bingads-webui-component-legacy/form/viewmodel/control/readonly-computed';

export default function text(local, attrs, field, viewModel) {
  const id = field.id;

  local.text = local.string ? local.string : local;
  local.placeholder = generate(field.placeholder, viewModel);
  local.describedby = ko.observableArray([`${id}-Remaining`, `${id}-Validation`]);
  local.strDescribedby = ko.computed(() => {
    const by = local.describedby() || [];

    return by.join(' ');
  });
  local.labelledBy = field.ariaLabel ? undefined : `${id}-Label`;
  local.ariaLabel = field.ariaLabel;
}
